/** Formatage de dates — responsabilité unique, formats mémoïsés. */
const date = new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "long", year: "numeric" });
const dateTime = new Intl.DateTimeFormat("fr-FR", {
  day: "numeric",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});
const full = new Intl.DateTimeFormat("fr-FR", { dateStyle: "full", timeStyle: "short" });

export const fmtDate = (iso: string | Date) => date.format(new Date(iso));
export const fmtDateTime = (iso: string | Date) => dateTime.format(new Date(iso));
export const fmtFull = (iso: string | Date) => full.format(new Date(iso));

export const plural = (n: number, one: string, many = `${one}s`) => (n > 1 ? many : one);

/** ISO -> valeur d'un <input type="datetime-local"> (heure locale). */
export function toDateTimeLocal(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  const p = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}

/** Valeur d'un <input type="datetime-local"> -> ISO. */
export const fromDateTimeLocal = (v: string): string => new Date(v).toISOString();

/** "il y a 3 min", "il y a 2 h", "hier", … */
export function timeAgo(iso: string): string {
  const s = Math.round((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "à l'instant";
  const m = Math.round(s / 60);
  if (m < 60) return `il y a ${m} min`;
  const h = Math.round(m / 60);
  if (h < 24) return `il y a ${h} h`;
  const d = Math.round(h / 24);
  if (d === 1) return "hier";
  if (d < 7) return `il y a ${d} j`;
  return fmtDate(iso);
}
